<template>
<div class="article" v-if="articleData">
  <!--顶部下载-->
  <headdownload></headdownload>
  <!--顶部游戏大图-->
  <header-cover :cover-url="articleData.picUrl"></header-cover>
<!-- 游戏一句话描述 -->
  <div class="area" v-if="articleData.title">
    <div class="recommend">{{ articleData.title }}</div>
  </div>
<!--  玩法介绍-->
  <div class="area">
    <div class="playing-method">
      <div class="playing-method-user">
        <img :src="articleData.appTopicUser.headIcon">
        <span class="playing-method-user-name">{{ articleData.appTopicUser.nickName }}</span>
      </div>
      <div class="playing-method-message">
        <div class="playing-method-message-item">
          <i class="fa fa-clock-o" aria-hidden="true"></i>
          <span>{{ articleData.releaseTime | dateTimeStr }}</span>
        </div>
        <div class="playing-method-message-item">
          <i class="fa fa-eye" aria-hidden="true"></i>
          <span>{{ articleData.viewCount }}</span>
        </div>
        <div class="playing-method-message-item">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span>{{ articleData.tagName }}</span>
        </div>
      </div>
<!--      <div class="playing-method-txt">高速行驶，以保证碾压它们，此外使用武器冲锋枪射 杀它们效果也相当不错。还可以升级购买车辆及其 他武器作战哟！</div>-->
    </div>
  </div>
  <div class="area" v-if="false">
    <!--  游戏简介-->
    <tool-describe></tool-describe>
  </div>
  <div class="area" v-if="items">
    <div class="evaluating">
      <div class="evaluating-exhibition" v-for="(item,index) in items" :key="index">
        <img v-if="item.appTopicItem.content.imgUrl" :src="item.appTopicItem.content.imgUrl">
        <div v-if="item.appTopicItem.content.text">{{ item.appTopicItem.content.text }}</div>
        <div class="link" v-if="item.appTopicItem.linkTitle" @click="openOfficial"><i class="fa fa-link" aria-hidden="true" ></i>{{ item.appTopicItem.linkTitle }}</div>
      </div>

      <div class="evaluating-consult">
        <div class="evaluating-consult-conter" @click="openOfficial">
          <img src="https://ws.resource.ccplay.cn/media/images/topic/2021/06/25/1022-30-373/950.jpg-no.tailor.q90">
          <span>若有疑问，可联系官方客服QQ号</span>
          <span class="number">（342289099)</span>
        </div>
      </div>
    </div>
  </div>
  <div class="area" v-if="ommentListData.length>1 && false">
    <div class="discuss">
      <div class="discuss-title">
        <div class="discuss-title-amount">
          <div class="amount-title">全部评价</div>
          <div class="amount-txt">（{{ ommentListData.length }}）</div>
        </div>
        <div class="sort" @click="openOfficial">
          <div class="pick">正序</div>
          <div class="segmentation">|</div>
          <div>倒序</div>
        </div>
      </div>
      <div class="discuss-center">
        <div class="discuss-center-item" v-for="(item,index) in ommentListData" :key="index" @click="openOfficial">
          <img class="head-portrait " src="https://ws.resource.ccplay.cn/media/images/topic/2021/06/25/1022-30-373/950.jpg-no.tailor.q90">
          <div class="details">
            <div class="details-name">{{ item.commentUser.nickName }}</div>
            <div class="details-time">{{ item.comment.updateTime | dateTimeStr }}</div>
            <div class="details-txt">{{ item.comment.content }}</div>
            <div class="details-imgs">
              <img v-for="(item,index) in item.comment.imgs" :key="index" :src="item">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--底部下载-->
  <floordownload></floordownload>
</div>
</template>

<script>
import Headdownload from './template/headdownload'
import HeaderCover from './template/headerCover'
import ToolDescribe from './template/toolDescribe'
import Floordownload from './template/floordownload'
import overallData from '../../public/js/overall'
import axios from 'axios' // 全局的一些配置项

export default {
  name: 'Article',
  components: { Floordownload, ToolDescribe, HeaderCover, Headdownload },
  filters: {
    // 日期字符串格式
    dateTimeStr: function (val) {
      if (val === '' || val == null) {
        return ''
      }
      const dateTime = new Date(val)
      const dateStr = {
        year: dateTime.getUTCFullYear(),
        month: dateTime.getMonth() + 1 >= 10 ? dateTime.getMonth() + 1 : '0' + (dateTime.getMonth() + 1),
        day: dateTime.getDate() >= 10 ? dateTime.getDate() : '0' + dateTime.getDate(),
        hour: dateTime.getHours() >= 10 ? dateTime.getHours() : '0' + dateTime.getHours(),
        minute: dateTime.getMinutes() >= 10 ? dateTime.getMinutes() : '0' + dateTime.getMinutes(),
        second: dateTime.getSeconds() >= 10 ? dateTime.getSeconds() : '0' + dateTime.getSeconds()
      }
      return dateStr.year + '-' + dateStr.month + '-' + dateStr.day
      // return dateStr.year + '-' + dateStr.month + '-' + dateStr.day + ' ' + dateStr.hour + ':' + dateStr.minute + ':' + dateStr.second
    }
  },
  data () {
    return {
      axiosUrl: overallData.axiosUrl, // 测试环境
      //
      articleData: null,
      // 顶部大图
      picUrl: null,
      // 文章数据
      items: null,
      // 评论
      ommentListData: null,
      // 文章id
      id: ''
    }
  },
  created () {
    const urlDataJson = {}
    if (window.location.hash.indexOf('?') !== -1) {
      const urlData = window.location.hash.split('?')[1].split('&')
      for (const urlDatum of urlData) {
        urlDataJson[urlDatum.split('=')[0]] = urlDatum.split('=')[1]
      }
      console.log('urlDataJson', urlDataJson)
    }

    this.getByIdNew(urlDataJson.itemId)
    this.ommentList(urlDataJson.itemId)
    this.id = urlDataJson.itemId
  },
  methods: {
    openOfficial () {
      window.location.href = 'sbapp:///editor_detail?id=' + this.id
      window.location.href = 'https://m.ccspeed.cn/'
    },
    // 评论
    ommentList (appTopicId) {
      const _this = this
      axios.get(this.axiosUrl + '/appTopic/comment/commentList', {
        params: {
          appTopicId: appTopicId,
          orderType: 1
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.ommentListData = response.data.list
            console.log(response)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    qqgroup () {
      // const _this = this
      axios.get(this.axiosUrl + '/qqgroup/index', {
        params: {
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            console.log(response)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getByIdNew (itemId) {
      const _this = this
      axios.get(this.axiosUrl + '/content/appTopic/getByIdNew', {
        params: {
          itemId: itemId // ID
        }
      })
        .then(function (response) {
          if (response.code === 100000) {
            _this.articleData = response.data
            _this.items = response.data.items
            const items = []
            _this.items.map(function (item) {
              item.appTopicItem.content = JSON.parse(item.appTopicItem.content)
              items.push(item)
            })
            _this.items = items
            console.log(items)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.article{
  padding-bottom: 45px;
}
.discuss{
  .discuss-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px;
    .discuss-title-amount{
      display: flex;
      align-items: center;
      .amount-title{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #F5F5F5;
      }
      .amount-txt{
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #4C5C6D;
      }
    }
    .sort{
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4C5C6D;
      .segmentation{
        color: #4C5C6D;
        padding: 0 12px;
      }
      .pick{
        color: #2992FF;
      }
    }
  }
  .discuss-center{
    .discuss-center-item{
      display: flex;
      justify-content: flex-start;
      border-top: 1px solid rgba(255,255,255,0.1);
      padding-top: 16px;
      margin-bottom: 25px;
      .head-portrait{
        width: 40px;
        height: 40px;
        background: #202632;
        border-radius: 50%;
      }
      .details{
        margin-left: 6px;
        .details-name{
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 21px;
        }
        .details-time{
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #4C5C6D;
        }
        .details-txt{
          margin: 10px 0;
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #F5F5F5;
          line-height: 22px;
        }
        .details-imgs{
          >img{
            width: 32%;
            height: 70px;
            margin-right: 1%;
          }
        }
      }
    }
  }
}

.evaluating{
  .evaluating-title{
    >img{
      width: 11px;
      height: 11px;
    }
    >span{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2992FF;
      margin-right: 8px;
    }
  }
  .evaluating-exhibition{
    >img{
      width: 100%;
      margin-top: 23px;
    }
    >div{
      margin-top: 22px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      line-height: 25px;
    }
    .link{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2992FF;
      line-height: 25px;
      .fa{
        transform: rotateY(180deg);
        -webkit-transform: rotateY(180deg); /* Safari 与 Chrome */
      }
    }
  }
  .evaluating-consult{
    margin-top: 24px;
    display: flex;
    justify-content: center;
    .evaluating-consult-conter{
      padding: 13px 17px;
      background: linear-gradient(90deg, #0E3147, #115855);
      border-radius: 22px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      >img{
        width: 22px;
        height: 22px;
        margin-right: 7px;
      }
      .number{
        color: #00F1C2;
      }
    }

  }
}
.playing-method{
  .playing-method-user{
    display: flex;
    align-items: center;
    >img{
      width: 26px;
      height: 26px;
      border-radius: 100px;
    }
    .playing-method-user-name{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F5F5F5;
      margin-left: 6px;
    }
  }
  .playing-method-message{
    display: flex;
    margin-top: 10px;
    .playing-method-message-item{
      margin-right: 25px;
      display: flex;
      align-items: center;
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4C5C6E;
      >img{
        width: 11px;
        height: 13px;
      }
      >span{
        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #4C5C6E;
        margin-left: 5px;
      }
    }
  }
  .playing-method-txt{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68829E;
    line-height: 25px;
    margin-top: 22px;
  }
}

.recommend{
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #F5F5F5;
  line-height: 31px;
  margin-top: 5px;
}

.Instrument{
  padding-bottom: 50px;
}
.area{
  padding: 0 13px;
  margin-bottom: 30px;
}
.area-deficiency{
  padding-right: 0;
  margin-bottom: 25px;
}
.area-title{
  background-color: #272D3B;
  margin-bottom: 0px;
}

</style>
